import type { TeamInfoData } from '../types';

export function getPlayerFlagSrc(
  isHome: boolean,
  teams: TeamInfoData,
  flag?: string | null,
): string | undefined {
  const hideFlags = isHome ? teams.home.isNationalTeam : teams.away.isNationalTeam;
  if (hideFlags) return undefined;
  return flag ?? undefined;
}
